export default __webpack_public_path__ + "9d0b16c.png";